import { createSlice } from "@reduxjs/toolkit";

export const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState: {
    user: null,
    accessToken: null,
  },

  reducers: {
    setAdminUser: (state, action) => {
      state.user = action.payload;
    },

    setAdminTokens: (state, action) => {
      state.accessToken = action.payload.access_token;
    },

    clearAdminAuth: (state) => {
      state.user = null;
      state.accessToken = null;
    },
  },
});

export const { setAdminUser, setAdminTokens, clearAdminAuth } =
  adminAuthSlice.actions;

export default adminAuthSlice.reducer;
